const ScrapbookEmpty = () => {
    return (
        <div className="h-64 flex justify-center items-center">
            <p>The scrapbook does not have images at the moment!</p>
        </div>
    );
};

export default ScrapbookEmpty;
